export default [{"url":"https://mike-0.api.invexerp.io","name":"Branch 1","port":"5032","isStore":true,"isHQ":true}]